<template>
  <button
    id="label-anError"
    class="reportProblem"
    @click="$emit('toggle-visible')"
  >
    <IconWrap
      class="mr-1"
      label="anError"
      width="16"
      height="16"
    >
      <IconError />
    </IconWrap>
    {{ $t("pages.visitImage.submitError") }}
  </button>
</template>

<script>
import IconError from '@/assets/images/icons/Error';
import IconWrap from '@/assets/images/icons';

export default {
  name: 'ButtonReportProblem',

  components: {
    IconWrap,
    IconError
  },

  emits: ['toggle-visible']
};
</script>

<style lang="postcss" scoped>
.reportProblem{
  @apply flex items-center text-sm text-red-400 no-underline;

  &:hover{
    @apply text-red-200;
  }
}
</style>
